module.exports = __webpack_public_path__ + "img/201711-1.c62695c0.jpg";